﻿import Carousel from './lib/carousel';
import SwipeDetect from './lib/swipe';
import Tab from './lib/tab';
import Util from './lib/util'
import sessionTimeout from './lib/bootstrap-session-timeout.js';

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.3.1): main.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

(() => {
    if (typeof $ === 'undefined') {
        throw new TypeError('Bootstrap\'s JavaScript requires jQuery. jQuery must be included before Bootstrap\'s JavaScript.')
    }

    const version = $.fn.jquery.split(' ')[0].split('.')
    const minMajor = 1
    const ltMajor = 2
    const minMinor = 9
    const minPatch = 1
    const maxMajor = 4

    if (version[0] < ltMajor && version[1] < minMinor || version[0] === minMajor && version[1] === minMinor && version[2] < minPatch || version[0] >= maxMajor) {
        throw new Error('Bootstrap\'s JavaScript requires at least jQuery v1.9.1 but less than v4.0.0')
    }

    function equalize($thisObj) {
        var maxHeight = 0;

        $thisObj.each(function () {
            if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
        });

        if (maxHeight > 0) $thisObj.height(maxHeight);
    }

    //Equalise carousel slide height
    if ($('.carousel.slide').length > 0 && $('.carousel.slide').is(':visible')) {
        $('.carousel.slide').each(function () {
            var $thisSlide = $(this);

            if ($thisSlide.find('.carousel-item').length > 1) {
                equalize($thisSlide.find('.carousel-item'));

                SwipeDetect($thisSlide[0], (direction) => {
                    if (direction == 'left') $thisSlide.carousel('next');
                    if (direction == 'right') $thisSlide.carousel('prev');
                }, 50);
            } else {
                $thisSlide.find('.carousel-control-prev,.carousel-control-next,.carousel-indicators').hide();
            }
        })

    }

    //Allow burger bar menu to close on page click
    $('body').on('click', 'main, footer', function () {
        if ($('#menuToggle input[type=checkbox]').is(':visible') && $('#menuToggle input[type=checkbox]').prop('checked')) $('#menuToggle input[type=checkbox]').prop('checked', false);
    });

    //Shorten login button text for mobile view
    let $loginBtn = $('.main-header-login .login-btn');
    if ($loginBtn.length > 0) {
        let loginText = '';
        $loginBtn.each((key, thisBtn) => {
            loginText = $(thisBtn).text().trim().split(' ');
            if (loginText.length == 2 && loginText[1] == 'się') $(thisBtn).html(loginText[0]).append($('<span>').addClass('d-none d-lg-inline').text(' ' + loginText[1]));
        })
    }

    // ------ Google Analytics scripts started

    // GA4 Scripts for Onclick of tab link
    $('section.sec-tab a.nav-tab__link').click(function () {
        var action = $(this).html();
        var pageurl = $(location).attr('href');
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'gaevent',
            'category': 'Click Tab',
            'action': action,
            'label': pageurl
        });
    });

    //GA4 Scripts for Onclick of document download link
    $('a.box-with-border-link').on('click', function () {
        var label = $(this).text();
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'gaevent',
            'category': 'Download document',
            'label': label
        });
    });

    // GA Scripts for Onclick of Loan apply button
    $('form.calc-form a.js-calc-submit').click(function () {
        var label;
        var text = $(this).text();
        if ($('.calc-offer-details ul li a.calc-product-details').hasClass('active')) {
            label = $('.calc-offer-details ul li a.calc-product-details.active').text();
        }
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'gaevent',
            'category': 'Click button',
            'action': text,
            'label': label
        });
    });
    //Google Analytics Scripts ended here    

    if ($(".health-check-info").length == 1) {
        healthCheck().then((data) => {
        }).catch((error) => {
            console.log('health check - ' + error);
        });

        function healthCheck() {
            return new Promise((resolve, reject) => {
                $.ajax({
                    url: '/api/sitecore/widget/GetPartialHealthCheckComponent',
                    type: 'POST',
                    data: null,
                    success: function (data) {
                        $(".health-check-info").append(data.PartialView);
                        $('div.info-content .loading-screen').hide();
                    },
                    error: function (error) {
                        $(".health-check-info").append('<h3>Error!</h3>');
                        $('div.info-content .loading-screen').hide();
                    },
                })
            })
        }
    }

    //Add extra links to sticky bookmark at top
    if ($('.sub-nav').length > 0) {
        var distance = $('.sub-nav').offset().top;
        var mobDistance = 600;
        var $window = $(window);
        $window.scroll(function () {
            if (window.innerWidth < 992) {
                $('.sub-nav').toggleClass('top-of-page', $window.scrollTop() >= mobDistance);
            } else {
                $('.sub-nav').toggleClass('top-of-page', $window.scrollTop() >= distance);
            }
        });
    }
})()

export {
    Util,
    Carousel,
    Tab,
    sessionTimeout
}